module.exports = "/app/main/img/extra-seat-v2.e6217d83.png";